/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './PeriodSelector.scss';

import React from 'react';
import { connect } from 'react-redux';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import {
  getPeriodSelection,
  getPerformanceOptions
} from 'state/performance/PerformancePageSelectors';

import { func, string } from 'prop-types';

const PeriodSelector = ({
  options,
  selected,
  toggleTimePeriod,
  timePeriodLabel,
  onChange
}) => {
  return (
    <div id="period-selector">
      {toggleTimePeriod && (
        <div className="select-labels">
          <span>Time Period</span>
          {timePeriodLabel ? (
            <a onClick={toggleTimePeriod}>{timePeriodLabel}</a>
          ) : (
            <span />
          )}
        </div>
      )}
      <Dropdown options={options} onChange={onChange} selected={selected} />
    </div>
  );
};

PeriodSelector.propTypes = {
  toggleTimePeriod: func,
  timePeriodLabel: string
};

PeriodSelector.defaultProps = {
  timePeriodLabel: 'View Time Period'
};

const mapStateToProps = (state, { filterType }) => {
  return {
    options: getPerformanceOptions(state),
    selected: getPeriodSelection(state, filterType)
  };
};

export default connect(mapStateToProps)(PeriodSelector);
